/* Oblíbená díla: společný sklad + srdíčka přímo v mřížce (2026-09-19).

   PROČ SAMOSTATNÝ SOUBOR: srdce potřebují tři různá místa — prohlížečka děl
   (assets/listovani.js), výpis oblíbených (assets/oblibene.js) a nově i dlaždice
   v mřížce. Tři kopie téhož ukládání by se dřív nebo později rozešly.

   KDE TO ŽIJE: v prohlížeči návštěvníka (localStorage), ne v zákaznickém účtu —
   Shopify sám žádný seznam přání nemá. Uložené tedy zůstane na tom přístroji
   a v tom prohlížeči, kde ho někdo označil.

   Každý přístup k úložišti je v try/catch schválně: v anonymním okně nebo při
   zakázaných datech webu umí vyhodit výjimku i samotné čtení, a to by shodilo
   celou stránku. Když úložiště není, oblíbená prostě nejsou.

   Ukládá se celý záznam (název, cena, adresa, obrázek), ne jen handle — stránka
   s výpisem tak nemusí nic dotahovat ze serveru. */
(function () {
  'use strict';

  var KLIC = 'galelie-oblibene';

  function nacti() {
    try {
      var syrove = window.localStorage.getItem(KLIC);
      var pole = syrove ? JSON.parse(syrove) : [];
      return Object.prototype.toString.call(pole) === '[object Array]' ? pole : [];
    } catch (e) {
      return [];
    }
  }

  function uloz(pole) {
    var ok = true;
    try {
      window.localStorage.setItem(KLIC, JSON.stringify(pole));
    } catch (e) {
      ok = false;
    }
    // Událost `storage` se ve stránce, která zapisuje, nespouští. Bez téhle
    // zprávy by se počet u srdce v hlavičce srovnal až při dalším načtení.
    try {
      window.dispatchEvent(new Event('galelie-oblibene-zmena'));
    } catch (e) {
      /* Starší prohlížeče bez konstruktoru Event: počet počká na načtení. */
    }
    return ok;
  }

  function kde(pole, handle) {
    for (var i = 0; i < pole.length; i++) {
      if (pole[i].handle === handle) return i;
    }
    return -1;
  }

  function jeUlozene(handle) {
    return handle ? kde(nacti(), handle) !== -1 : false;
  }

  /** Přepne dílo a vrátí true, když je nově uložené. */
  function prepni(d) {
    if (!d || !d.handle) return false;
    var pole = nacti();
    var i = kde(pole, d.handle);
    if (i !== -1) {
      pole.splice(i, 1);
      uloz(pole);
      return false;
    }
    pole.push({
      handle: d.handle,
      nazev: d.nazev || '',
      url: d.url || '',
      cena: d.cena || '',
      obrazek: d.obrazek || d.hotovy || '',
      kdy: Date.now()
    });
    uloz(pole);
    return true;
  }

  var SRDCE_SVG =
    '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
    '<path d="M12 20.6 4.3 13a4.6 4.6 0 0 1 .2-6.8 4.6 4.6 0 0 1 6.3.4l1.2 1.3 1.2-1.3' +
    'a4.6 4.6 0 0 1 6.3-.4 4.6 4.6 0 0 1 .2 6.8z"/></svg>';

  window.GalelieOblibene = {
    nacti: nacti,
    uloz: uloz,
    jeUlozene: jeUlozene,
    prepni: prepni,
    SRDCE_SVG: SRDCE_SVG
  };

  /* --------------------------------------------------- srdíčka v mřížce */

  // Majitelka (2026-09-19): „bylo by fajn, kdyby člověk mohl dávat srdíčka
  // i v části, kde vidí všechny obrazy vedle sebe, ne jen v těch slidových
  // náhledech."
  //
  // Srdce se do dlaždic doplňují skriptem, ne v Liquidu: mřížky jsou dvě
  // (úvodní stránka a stránka kolekce) ve dvou různých sekcích a takhle stačí
  // jedno místo. Chvilka, než se objeví, u vedlejšího ovládání nevadí.
  function handleZUrl(u) {
    if (!u) return '';
    var m = String(u).split('?')[0].match(/\/products\/([^/]+)/);
    return m ? m[1] : '';
  }

  function zKarty(karta) {
    var odkaz = karta.matches('a') ? karta : karta.querySelector('a[href*="/products/"]');
    if (!odkaz) return null;
    var obr = karta.querySelector('img');
    var nadpis = karta.querySelector('h3');
    var cena = karta.querySelector('.art-price') || karta.querySelector('p');
    var handle = handleZUrl(odkaz.getAttribute('href'));
    if (!handle) return null;
    return {
      handle: handle,
      nazev: nadpis ? nadpis.textContent.trim() : '',
      cena: cena ? cena.textContent.trim() : '',
      url: odkaz.getAttribute('href'),
      obrazek: obr ? (obr.getAttribute('src') || obr.currentSrc || '') : ''
    };
  }

  function osadMrizku() {
    var karty = document.querySelectorAll('.art-card, .product-card');
    if (!karty.length) return;

    var mrizka = document.querySelector('[data-listovani], .product-grid, .art-grid');
    var popisPridat = (mrizka && mrizka.getAttribute('data-listovani-oblibene')) || 'Přidat do oblíbených';
    var popisZrus = (mrizka && mrizka.getAttribute('data-listovani-oblibene-zrus')) || 'Odebrat z oblíbených';

    Array.prototype.forEach.call(karty, function (karta) {
      if (karta.querySelector('.mrizka-srdce')) return;
      var d = zKarty(karta);
      if (!d) return;

      var tlacitko = document.createElement('button');
      tlacitko.type = 'button';
      tlacitko.className = 'mrizka-srdce';

      function srovnej() {
        var ulozene = jeUlozene(d.handle);
        tlacitko.setAttribute('aria-pressed', ulozene ? 'true' : 'false');
        tlacitko.setAttribute('aria-label', ulozene ? popisZrus : popisPridat);
      }

      tlacitko.innerHTML = SRDCE_SVG;
      srovnej();

      // Dlaždice je odkaz (nebo ho obsahuje) a klepnutí na ni navíc otevírá
      // prohlížečku. Srdce tedy musí obojí zastavit, jinak by uložení zároveň
      // odnavigovalo pryč.
      tlacitko.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        prepni(d);
        srovnej();
      });

      karta.appendChild(tlacitko);
      karta.setAttribute('data-ma-srdce', '');
    });

    // Když se totéž dílo odloží jinde (prohlížečka, druhá záložka).
    function srovnejVse() {
      Array.prototype.forEach.call(document.querySelectorAll('.mrizka-srdce'), function (t) {
        var karta = t.closest('.art-card, .product-card');
        var d = karta && zKarty(karta);
        if (!d) return;
        var ulozene = jeUlozene(d.handle);
        t.setAttribute('aria-pressed', ulozene ? 'true' : 'false');
        t.setAttribute('aria-label', ulozene ? popisZrus : popisPridat);
      });
    }

    window.addEventListener('galelie-oblibene-zmena', srovnejVse);
    window.addEventListener('storage', srovnejVse);
    window.addEventListener('pageshow', srovnejVse);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', osadMrizku);
  } else {
    osadMrizku();
  }
})();
